import { Badge, Loader } from "@mantine/core";
import { useTranslation } from "react-i18next";

function ImportStatusBadge({ status, ...props }) {
  const { t } = useTranslation("ImportStatus");

  switch (status) {
    case "pending":
      return (
        <Badge color="blue" {...props}>
          {t("pending")}
        </Badge>
      );
    case "processing":
      return (
        <Badge
          leftSection={<Loader color="white" size={12} />}
          color="blue"
          {...props}
        >
          {t("processing")}
        </Badge>
      );
    case "succeeded":
      return (
        <Badge color="green" {...props}>
          {t("succeeded")}
        </Badge>
      );
    case "completedWithErrors":
      return (
        <Badge color="yellow" {...props}>
          {t("completedWithErrors")}
        </Badge>
      );
    case "failed":
      return (
        <Badge color="red" {...props}>
          {t("failed")}
        </Badge>
      );
    default:
      return (
        <Badge color="gray" {...props}>
          {t("unknown")}
        </Badge>
      );
  }
}

export default ImportStatusBadge;
